<template>
    <div class="home">
        <Header :app="app" title="Attend" />

        <div class="content">
            <table class="table">
                <tbody>
                    <tr v-for="location in app.sortedLocations" :key="location.id">
                        <td>
                            <router-link :to="{ name: 'location', params: { id: location.id } }">
                                {{location.name}}
                            </router-link>
                        </td>
                    </tr>

                    <tr>
                        <td>
                            <router-link to="/analytics">
                                <strong>
                                    Analytics
                                </strong>
                            </router-link>
                        </td>
                    </tr>

                    <tr>
                        <td>
                            <router-link to="/settings">
                                <strong>
                                    Staff
                                </strong>
                            </router-link>
                        </td>
                    </tr>
                </tbody>
            </table>

            <br>

            <a href="javascript:;" class="button full-width" v-on:click="app.addLocation()">
                + Add Location
            </a>
        </div>
    </div>
</template>

<script>
import Header from '@/components/header/component.vue';

export default {
    name: 'home',
    props: ['app'],
    components: {
        Header
    }
};
</script>
